// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__b9rwa","iconBtn":"styles_iconBtn__YWWcM","closeBtn":"styles_closeBtn__G+1WE","disabled":"styles_disabled__kl7KI"};